import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ActionButton, Breadcrumb } from '@app-model/layout';
import { SideFilterConfigOptions } from '@app-shared/filter/side-filter/side-filter.component';

@Component({
    selector: 'app-layout-restrict-header',
    templateUrl: './layout-restrict-header.component.html',
    styleUrls: ['./layout-restrict-header.component.scss'],
    standalone: false
})
export class LayoutRestrictHeaderComponent implements OnInit {

  @Input() breadcrumbList: Breadcrumb[];
  @Input() title: string;
  @Input() filterConfiguration: SideFilterConfigOptions;
  @Input() actionButton: ActionButton;

  tooltip: boolean = false;

  @Output() filterChanged = new EventEmitter<string>();

  constructor() { }

  ngOnInit(): void {
  }

  generateBreadcrumbLink(breadcrumb: Breadcrumb): string {
    if (breadcrumb.link != null || breadcrumb.link != undefined) 
      return breadcrumb.link;
    return '';
  }

  onChangeSideFilter(event) {
    this.filterChanged.emit(event);
  }

}
